import { PatchContentViews } from "src/types/global";
import { twMerge } from "tailwind-merge";

interface PatchContentHeaderProps {
  selectedView: PatchContentViews;
  setSelectedView: (view: PatchContentViews) => void;
}

function PatchContentHeader({ selectedView, setSelectedView }: PatchContentHeaderProps) {
  return (
    <div className="flex w-full items-center justify-center">
      <div
        onClick={() => setSelectedView(PatchContentViews.S_TIER)}
        className={twMerge(
          "flex h-14 w-1/3 cursor-pointer items-center justify-center border-b border-[#393939] font-unbounded text-[18px] font-extrabold leading-6 text-[#393939]  ",
          selectedView === "S TIER" && "border-[#aaa] text-[#aaa] ",
        )}
      >
        S TIER
      </div>
      <div
        onClick={() => setSelectedView(PatchContentViews.STATS)}
        className={twMerge(
          "flex h-14 w-1/3 cursor-pointer items-center justify-center border-b border-[#393939] font-unbounded text-[18px] font-extrabold leading-6 text-[#393939]  ",
          selectedView === "STATS" && "border-[#aaa] text-[#aaa] ",
        )}
      >
        STATS
      </div>
      <div
        onClick={() => setSelectedView(PatchContentViews.COMPS)}
        className={twMerge(
          "flex h-14 w-1/3 cursor-pointer items-center justify-center border-b border-[#393939] font-unbounded text-[18px] font-extrabold leading-6 text-[#393939]  ",
          selectedView === "COMPS" && "border-[#aaa] text-[#aaa] ",
        )}
      >
        COMPS
      </div>
    </div>
  );
}

export default PatchContentHeader;
